import { cn } from '@/util/cn'
import { InputHTMLAttributes } from 'react'

type Props = {
    id: string
    label: string
    name: string
    onChange?: (event: React.FormEvent<HTMLInputElement>) => void
} & InputHTMLAttributes<HTMLInputElement>

const Radio = ({ disabled, id, label, onChange, ...props }: Props) => (
    <div className="flex items-start gap-2">
        <div className="mt-1 grid place-items-center">
            <input
                type="radio"
                id={id}
                disabled={disabled}
                className={cn(
                    'm-0 transition-all',
                    'peer col-start-1 row-start-1 size-4 shrink-0',
                    'appearance-none rounded-full',
                    'ring-2 ring-giphyCharcoal',
                    'disabled:border-giphyLightGrey',
                    !disabled && 'cursor-pointer'
                )}
                onChange={onChange}
                {...props}
            />
            <div
                className={cn(
                    'pointer-events-none',
                    'col-start-1 row-start-1',
                    'size-3 rounded-full bg-giphyCharcoal transition-all',
                    'peer-checked:bg-giphyGreen',
                    'peer-checked:peer-disabled:bg-giphyLightGrey'
                )}
            />
        </div>
        <label htmlFor={id} className={cn('text-start', disabled ? 'text-giphyLightGrey' : 'hover:cursor-pointer')}>
            {label}
        </label>
    </div>
)

export default Radio
